<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import FileApi from '@/api/file.ts'
import type { FileCollection } from '@/types/file.ts'
let baseUrl = import.meta.env.VITE_BASE_URL

if (typeof baseUrl !== 'string' || baseUrl.length === 0) {
  throw new Error('VITE_BASE_URL is niet geconfigureerd')
} else {
  baseUrl = baseUrl.replace(/\/+$/, '')
}

const files = ref<FileCollection>({ items: {} })

const filesLoading = ref(false)
const filesError = ref(false)

const hasFiles = computed(() => Object.keys(files.value.items).length > 0)

async function loadFiles(): Promise<void> {
  filesLoading.value = true
  filesError.value = false

  try {
    files.value = await FileApi.list()
  } catch (error: unknown) {
    files.value = { items: {} }
    filesError.value = true

    console.error('Kon beschikbare bestanden niet laden:', error)
  } finally {
    filesLoading.value = false
  }
}

onMounted(loadFiles)
</script>

<template>
  <div class="container overview">
    <h1>Beschikbare bestanden</h1>

    <span v-if="filesLoading" class="loading-spinner" data-message="Laad beschikbare bestanden" />

    <span
      v-else-if="filesError"
      class="loading-error"
      data-message="Kon beschikbare bestanden niet laden"
    />

    <div v-else-if="!hasFiles" class="no-results">Geen resultaten gevonden</div>

    <ul v-else>
      <li
        v-for="(file, id, index) in files.items"
        :key="id"
        :class="index % 2 === 0 ? 'odd' : 'even'"
      >
        <a :href="`${baseUrl}/shared/${encodeURIComponent(id)}`" :download="file">
          {{ file }}
        </a>
      </li>
    </ul>
  </div>
</template>
